/* eslint-disable @typescript-eslint/naming-convention */

// ---- 1. Real env vars ----
const REACT_APP_ENV: string = process.env.REACT_APP_ENV;
const REACT_APP_GATEWAY_URL: string = process.env.REACT_APP_GATEWAY_URL;
const REACT_APP_KEYCLOAK_REALM: string = process.env.REACT_APP_KEYCLOAK_REALM;
const REACT_APP_KEYCLOAK_URL: string = process.env.REACT_APP_KEYCLOAK_URL;
const REACT_APP_KEYCLOAK_CLIENT_ID: string =
  process.env.REACT_APP_KEYCLOAK_CLIENT_ID;
const REACT_APP_SOCKET_URL: string = process.env.REACT_APP_SOCKET_URL;

// ---- 2. Service groups + module paths ----
const SERVICE = {
  USER: 'services/user/api/v1',
  DATA: 'services/data/api/v1',
};

const MODULE = {
  INPUT_SOURCE: 'input_source',
  UNIFIED_DATA_SOURCE: 'unified_data_source',
  MASTER_DATA_MANAGEMENT: 'master_data_management',
  USER_MANAGEMENT: 'user_management',
  ORGANIZATION: 'organization',
  ROLES_PERMISSIONS: 'roles_permissions',
};

const buildUrl = (service: string, moduleName: string): string =>
  `${REACT_APP_GATEWAY_URL}/${service}/${moduleName}`;

// ---- 3. Final URLs ----
const REACT_APP_API_URL: string = buildUrl(SERVICE.DATA, MODULE.INPUT_SOURCE);
const REACT_APP_API_URL_UNIFIED: string = buildUrl(
  SERVICE.DATA,
  MODULE.UNIFIED_DATA_SOURCE
);
const REACT_APP_API_URL_MASTER: string = buildUrl(
  SERVICE.DATA,
  MODULE.MASTER_DATA_MANAGEMENT
);
const REACT_APP_USER_API_URL: string = buildUrl(
  SERVICE.USER,
  MODULE.USER_MANAGEMENT
);
const REACT_APP_API_URL_ORG: string = buildUrl(
  SERVICE.USER,
  MODULE.ORGANIZATION
);
const REACT_APP_API_URL_ROLE: string = buildUrl(
  SERVICE.USER,
  MODULE.ROLES_PERMISSIONS
);

export {
  REACT_APP_ENV,
  REACT_APP_KEYCLOAK_REALM,
  REACT_APP_KEYCLOAK_URL,
  REACT_APP_KEYCLOAK_CLIENT_ID,
  REACT_APP_API_URL,
  REACT_APP_API_URL_UNIFIED,
  REACT_APP_API_URL_MASTER,
  REACT_APP_USER_API_URL,
  REACT_APP_API_URL_ORG,
  REACT_APP_API_URL_ROLE,
  REACT_APP_SOCKET_URL,
};
